import { LoadingButton } from "@mui/lab";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { useState } from "react";
import { toast } from "react-toastify";

const MarketGrowthExportButton = ({ label = "خروجی Excel", onExport, disabled = false }) => {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    try {
      setLoading(true);
      await onExport();
      toast.success("فایل اکسل آماده دانلود است.");
    } catch (error) {
      toast.error(error?.message || "خطا در تهیه خروجی اکسل.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <LoadingButton
      variant="outlined"
      color="success"
      size="small"
      startIcon={<FileDownloadOutlinedIcon />}
      loading={loading}
      disabled={disabled}
      onClick={handleClick}
    >
      {label}
    </LoadingButton>
  );
};

export default MarketGrowthExportButton;
